

import Footer from "../components/Shared/Footer";
import UnhealthyScroll from "../components/Shared/UnHealthyScroll";

const Unhealthy = () => {

  return (
    <div>
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>Unhealthy dietary habits</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active">Resources</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-5 d-flex align-items-center">
              <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/Unhealthy/unhealthy-one.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>

            <div className="col-xl-7 ">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">
                        Unhealthy dietary habits
                      </h1>
                    </div>
                    <p className="font-xsm">
                      In simple terms, eating too much, too little, eating non-nutritious food or irregular timings are called unhealthy
                      dietary habits.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row  ">
            <div className="col-xl-7 d-flex align-items-center">
              <div>
                <div className="">
                  <div className="review-title">
                    <h1 className="font-lg mb-3 ">
                      Unhealthy dietary habits & health impact
                    </h1>
                  </div>
                  <p className=" font-xsm mb-2 justify_content">
                    Too less food leads to malnutrition and sub optimal
                    physical, mental and social growth. However, recently India
                    is also facing a challenge of too much eating. Too much food
                    intake can lead to abdominal obesity, make a person
                    overweight or obese. This can further lead to
                    non-communicable diseases like diabetes, high blood
                    pressure, high lipids, heart diseases etc. Estimate shows
                    that
                    <span className="fw-semibold color-blue-abdominal my-2">
                      56.4% of total disease burden in India is due to unhealthy
                      eating habits.
                    </span>
                    <br></br>
                    The prevalence of urban Indian population with abdominal
                    obesity, and those who are overweight and obese are 53.6%,
                    31.4% and 12.5% respectively.
                  </p>
                </div>

                <div>
                  <div className="font-sm mb-1 fw-semibold">
                    What is non-nutritious food?
                  </div>
                  <p className="font-xsm mb-2 justify_content">
                    Food items which are HIGH in saturated and trans-fat, salt,
                    sugar (refined sugar) and calories are considered non
                    nutritious. Any food items with only calories without
                    micronutrients are also considered as non-nutritious.
                  </p>
                </div>

                <div className="font-xsm fw-semibold color-blue-abdominal">
                  In simple terms, every second person has abdominal obesity and
                  every third is overweight
                </div>
              </div>
            </div>

            <div className="col-xl-5 d-flex align-items-center">
              <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/Unhealthy/unhealthy-two.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
        <div className="review-title text-center mb-3">
                  <h1 className="font-lg mb-2 ">What are irregular eating habits?</h1>
                  <div className="font-xsm">
                  It is advisable for a normal healthy individual to eat 3-4 times a day. <br></br>
                  Following are few examples of irregular eating habits: 
                  </div>
                </div>
          <div className="row">
            <div className="col-xl-5 p-4 ">
              <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/Unhealthy/irregular_eating_habits.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
            <UnhealthyScroll/>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space background-blue-color">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-xl-4 text-white px-3  d-flex justify-content-centre with-border">
              <div>
                <div className="font-md fw-semibold mb-3">
                  Does intermittent fasting helpful for weight loss and
                  prediabetes?
                </div>
                <div className="font-xsm">
                  Recent research has shown that, intermittent fasting can
                  achieve lower glucose levels and fasting insulin & improve
                  insulin resistance and weight control. There is evidence that
                  both alternate day fasting and periodic fasting may be
                  effective for weight loss, in lowering triglyceride
                  concentrations and blood pressure (a minimum weight loss of 6%
                  may be required for optimal results)
                </div>
              </div>
            </div>
            <div className="col-xl-4 text-white px-3  d-flex justify-content-centre with-border">
              <div>
                <div className="font-md fw-semibold mb-3">
                  Should Night shift worker skip dinners?
                </div>
                <div className="font-xsm">
                  Skipping meals is not advisable. Night shift workers have
                  different diurnal cycle and it may not be synchronised with
                  biological clocks. It is recommended to consult a dietician
                  and plan your daily dietary schedule.
                </div>
              </div>
            </div>
            <div className="col-xl-4 text-white px-3 d-flex justify-content-centre">
              <div>
                <div className="font-md fw-semibold mb-3">
                  I am nondiabetic. Should I reduce my daily carbohydrates?
                </div>
                <div className="font-xsm">
                  If you are consuming excess carbohydrates, you may be
                  benefitted from reducing your carbohydrates after consultation
                  with a dietician or health care professional.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
  <div className="container-fluid-lg">
    <div className="review-title mb-3">
      <h1 className="font-lg mb-2">References:</h1>
    </div>
    <div className="references">
      <p><strong>1.</strong> <a  >AHA scientific statement. Circulation. 2017;135: e96–e121</a></p>
      <p><strong>2.</strong> <a   >AHA scientific statement. Circulation. 2017;135:e96–e121.</a></p>
      <p><strong>3.</strong> <a   >AHA scientific statement. Circulation. 2017;135:e96–e121.</a></p>
      <p><strong>4.</strong> <a   >ICMR NIN RDAs for Indians 2020</a></p>
      <p><strong>5.</strong> <a    >What India Eats? ICMR NIN study</a></p>
      <p><strong>6.</strong> <a    >Ojo T K, Joshua O O, Ogogbede O J, et al. (September 05, 2022). Cureus 14(9): e28800.</a></p>
      <p><strong>7.</strong> <a   >AHA scientific statement. Circulation. 2017;135:e96–e121.</a></p>
    </div>
  </div>
</section>




      {/* <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-5  d-flex justify-content-center align-items-center">
              <div className="custom-image-container fresh-image-2">
                <img
                  src="../assets/images/Unhealthy/unhealthy-three.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>

            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">
                        Breakfast skipping and Health Impact
                      </h1>
                    </div>
                    <div className="font-md">
                      <p className="font-xsm">
                        Though there are mixed reports, some research highlights
                        the association between skipping breakfast and increased
                        risk of overweight and obesity, low nutritional adequacy
                        (not meeting daily nutritional requirement), higher
                        refined sugar intake, lower healthy eating index. Hence,
                        daily breakfast consumption may decrease the risk of
                        adverse effects related to glucose and insulin
                        metabolism and helpful in promoting healthy dietary
                        habits throughout the day. (Ref: AHA scientific
                        statement. Circulation. 2017;135:e96–e121. DOI:
                        10.1161/CIR.0000000000000476)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">
                        Irregular eating, meal freuqency and intermittant
                        fasting
                      </h1>
                    </div>
                    <div className="">
                      <p className="font-xsm">
                        There is research done on meal frequencies and its
                        health impact. Findings indicate that increasing meal
                        frequency may reduce cholesterol levels, whereas
                        decreasing meal frequency may have unfavourable effects.
                        The increased meal frequency pattern may be more
                        effective at lowering total and LDL cholesterol. Its
                        impact on positive impact on HDL and Triglycerides are
                        also significant. Hence, current research indicates that
                        4-6 meals per day would be healthy. (Ref: AHA scientific
                        statement. Circulation. 2017;135:e96–e121. DOI:
                        10.1161/CIR.0000000000000476)
                      </p>

                      <div className="font-sm fw-semibold mb-1">
                        Does intermittent fasting helpful for weight loss and
                        prediabetes?
                      </div>
                      <p className="font-xsm">
                        Yes !! Recent research has shown that, intermittent
                        fasting can achieve suitable glycemic targets, fasting
                        insulin & insulin resistance and weight control. There
                        is evidence that both alternate-day fasting and periodic
                        fasting may be effective for weight loss, although there
                        are no data that indicate whether the weight loss can be
                        sustained long term. In addition, both eating patterns
                        may be useful for lowering triglyceride concentrations
                        but have little or no effect on total, LDL, or HDL
                        cholesterol concentrations. These protocols may also be
                        beneficial for lowering blood pressure, but a minimum
                        weight loss of 6% may be required to see an effect.
                        (Ref: Ojo T K, Joshua O O, Ogedegbe O J, et al.
                        (September 05, 2022). Cureus 14(9): e28800. DOI
                        10.7759/cureus.28800, AHA scientific statement.
                        Circulation. 2017;135:e96–e121. DOI:
                        10.1161/CIR.0000000000000476).
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-5 ">
              <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/Unhealthy/unhealthy-four.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-5 ">
              <div className="custom-image-container fresh-image-2">
                <img
                  src="../assets/images/Unhealthy/unhealthy-five.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>

            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">
                        Late and/or heavy dinner and health
                      </h1>
                    </div>
                    <div>
                      <p className="font-xsm mb-2">
                        Late dinner increase night time sugar and lipid spikes.
                        Late  dinner followed by lack of activity during sleep
                        hours ultimately leads to abnormal sugar, lipid
                        profiles, insulin resistance and increased chances of
                        abdominal fat, overweight, obesity, diabetes and high
                        blood pressure. Late-night eating has been associated
                        with a greater risk of poor heart problems with higher
                        chances increased blood sugar and lipids in several
                        cross-sectional studies (Ref: AHA scientific statement.
                        Circulation. 2017;135:e96–e121. DOI:
                        10.1161/CIR.0000000000000476).
                      </p>
                    </div>

                    <div>
                      <div className="font-sm fw-semibold mb-1">
                        Should Night shift worker skip dinners?
                      </div>
                      <p className="font-xsm">
                        Skipping meals is not advisable. Night shifts workers
                        have different diurnal schedule and it may not
                        synchronised with biological clocks. However, having a
                        proper diet plan to match your energy needs,  work -rest
                        cycles and meeting your nutritional needs is advisable.
                         It is recommended to consult a dietician and plan your
                        daily dietary schedule.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">
                        Recommended carbohydrate intake
                      </h1>
                    </div>
                    <div>
                      <p className="font-xsm mb-2">
                        Indian Counsil of Medical Science recommends 130gm / day
                        of carbohydrates per day. (Ref: ICMR NIN RDAs for
                        Indians 2020
                      </p>
                    </div>

                    <div>
                      <div className="font-sm fw-semibold mb-1">
                        How much carbohydrates do we eat?
                      </div>
                      <p className="font-xsm mb-2">
                        Urban Indians are eating 289 g carbohydrates while in
                        rural region, an average adult consumed consume 368 g of
                        carbohydrates. It’s too much that recommended values.
                        (Ref: What India Eats?  ICMR NIN study)
                      </p>
                    </div>

                    <div>
                      <div className="font-sm fw-semibold mb-1">
                        I am non diabetic. Should I reduce my daily
                        carbohydrates?
                      </div>
                      <p className="font-xsm">
                        Carbohydrates are natural energy sources for the body.
                        Indian council of Medical Research (ICMR) recommends 130
                        gm / day of carbohydrates.  It is advisable to know your
                        daily carbohydrate intake. If you are consuming excess
                        carbohydrates, you may be benefitted from reducing your
                        carbohydrates after consultation with a dietician or
                        health care professional.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-5 ">
              <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/Unhealthy/unhealthy-six.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Unhealthy;
